import React, { useState, useEffect, useContext } from "react";
import styles from "./Header.module.scss";
import { formatDate } from "../utils/helpers";
import { Context } from "../Store";

const Header = (props) => {
  const [imgSrc, setImgSrc] = useState(`${process.env.PUBLIC_URL}/img/fc_stories_header_placeholder.webp`);
  const [state] = useContext(Context);

  const venue = state.venue.toLowerCase();
  const photoMob = `${process.env.PUBLIC_URL}/img/fc_stories_header_${venue}.webp`;

  useEffect(() => {
    const img = new Image();
    img.src = photoMob;
    img.onload = () => setImgSrc(photoMob);
  }, [photoMob]);

  return (
    <>
      {state.feedbackurl !== "" && state.country === "uk" && (
        <div className={styles.feedback}>
          <div>
            We'd love to hear your feedback{" "}
            <a href={state.feedbackurl} target="_blank" rel="noreferrer">
              here
            </a>
          </div>
        </div>
      )}
      {state.feedbackurl !== "" && state.country === "us" && (
        <div className={styles.feedback}>
          <div>
            Had a good time?{" "}
            <a href={state.feedbackurl} target="_blank" rel="noreferrer">
              Google
            </a>
            &nbsp;is dying to hear about it.
          </div>
        </div>
      )}
      {state.feedbackurl !== "" && state.country === "aus" && (
        <div className={styles.feedback}>
          <div>
            We'd love to header your feedback.{" "}
            <a href={state.feedbackurl} target="_blank" rel="noreferrer">
              Enter here
            </a>
          </div>
        </div>
      )}
      <div className={styles.header}>
        <div className={styles.photo}>
          <img src={imgSrc} alt={state.venue} />
        </div>

        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <div className={styles.circle}></div>
            <img src="./img/yourText.svg" alt="Your" className={styles.logoImage} />
            <h1>Flight Club</h1>
            <img src="./img/storyText.svg" alt="Story" className={styles.logoImage} />
          </div>
          <div className={styles.storyInfo}>
            <div className={styles.storyDate}>{formatDate(state.date, styles.dateSuffix)}</div>
            <div className={styles.oneLine}>
              <div>{state.venue}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
                <path d="M7.83969 5.2285L3.91984 0L0 5.22646L3.91984 10.455L7.83969 5.2285Z" fill="white" />
              </svg>
              <div>{state.players.length} Players</div>
            </div>
          </div>
        </div>
        <div>
          <img src="./img/dart.gif" alt="Dart" className={styles.dart} />
        </div>
      </div>
    </>
  );
};

export default Header;
